var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopePrivilegeRead = function SvgScopePrivilegeRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.667 8.5V5.407c0-.613-.508-1.11-1.134-1.11s-1.133.497-1.133 1.11M4.6 7.63V9.48m0-1.851V3.185c0-.613.507-1.11 1.133-1.11.626-.001 1.134.497 1.134 1.11M4.6 7.63c0-.614-.507-1.111-1.133-1.111s-1.134.497-1.134 1.11v1.482c0 2.783 2.087 5.087 4.81 5.493M6.867 3.185V7.26m0-4.074v-.74c0-.614.507-1.112 1.133-1.112s1.133.498 1.133 1.111v.741m0 0V7.26m0-4.074c0-.613.508-1.11 1.134-1.11.626-.001 1.133.497 1.133 1.11v2.222m0 0V7.26M8.094 12.755c-.049-.077-.073-.116-.086-.175a.4.4 0 0 1 0-.16c.013-.06.037-.098.086-.175C8.494 11.61 9.685 10 11.5 10s3.006 1.609 3.406 2.245c.049.077.073.116.086.175.01.045.01.115 0 .16-.013.06-.037.098-.086.175-.4.636-1.591 2.245-3.406 2.245s-3.006-1.609-3.406-2.245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11.5 13.571c.59 0 1.067-.48 1.067-1.071 0-.592-.478-1.071-1.067-1.071-.59 0-1.067.48-1.067 1.071 0 .592.478 1.071 1.067 1.071"
  })));
};
export default SvgScopePrivilegeRead;